<template >
   <div class="ais-sort-results">
  <ais-sort-by
    :items="[
      { value: 'development_api::merchant-web.merchant-web', label: 'Top Rated' },
      { value: 'development_api::merchant-30day_ranking_desc', label: 'Trending' },
      // { value: 'development_api::merchant-discount_based_ranking_desc', label: 'Offers' },
      // { value: 'merchantName-asc', label: 'A-z' },
    ]"
  >
    <template #default="{ items, refine, currentRefinement }">
      <div class="ais-sort-by">
        <div
          v-for="item in items"
          :key="item.value"
          class="ais-sort-by-item"
          :class="{ active: item.value === currentRefinement }"
          @click="refine(item.value)"
        >
          <div class="sort-item">{{ item.label }}</div>
        </div>
      </div>
    </template>
  </ais-sort-by>
</div>
</template>

<script>
import { AisSortBy } from 'vue-instantsearch/vue3/es';
export default {
  components: {
    AisSortBy
  }
}
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=Raleway:wght@500;700&display=swap");

.ais-sort-by {
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #D9D9D9;
  margin-bottom: 10px;
  align-self: stretch;
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: flex-start;
}
.ais-sort-by-item {
  flex: 1;
  text-align: center;
  padding: 10px;
  cursor: pointer;
  border-bottom: 2px solid transparent;
  align-self: stretch;
    position: relative;
    line-height: 24px;
    font-weight: 500;
    white-space: nowrap;
    padding-bottom: 5px;
    font-size: 12px;
}
.ais-sort-by-item.active {
  border-bottom-color: #000000;
  font-weight:bold;
}
.sort-item{
    font-family:raleway;
}
.ais-sort-results {
    margin-top: 8px;
}
</style>